import type { FlowStep, FlowStepSetter } from "@/components/helpers/Flow/types"

/**
 * Creates a type-safe flow step setter from a raw `FlowStep` updater.
 *
 * Callers get the ergonomic `setStep("stepOne")` / `setStep("stepTwo", { title: "hello" })` API,
 * while `set` receives the `{ key, props }` step state to persist in the flow store.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createFlowStepSetter<T extends Record<string, React.ComponentType<any>>>(
  set: (step: FlowStep<T>) => void
): FlowStepSetter<T> {
  // The public signature enforces key/props correlation; internally we can only handle the erased pair.
  return (key: keyof T, props?: unknown) => {
    set({ key, props } as FlowStep<T>)
  }
}
